import { ChevronDown } from "lucide-react";

interface DropdownButtonProps {
    isOpen: boolean;
    setIsOpen: (open: boolean) => void;
    label: string;
    className?: string;
}

export function DropdownButton({ isOpen, setIsOpen, label, className = "" }: DropdownButtonProps) {
    return (
        <button
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className={`inline-flex items-center justify-center gap-1 assented rounded-full h-10 pl-3 pr-2 text-md text-foreground leading-1 ${className}`}
        >
            {label}
            <ChevronDown className={`h-4 w-4 transition-transform ${isOpen ? "rotate-180" : ""}`} />
        </button>
    );
}
